export default function AffiliateAmazon({ title, link }) {
  return (
    <a
      href={link}
      className="affiliate-btn amazon-btn"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      {title}
    </a>
  );
}
